import React from 'react';
import Typography from '@material-ui/core/Typography';
import { CREDIT } from '../constants';
import makeStyles from '@material-ui/core/styles/makeStyles';
import type { AreaImageProps } from './Area';

type ImageWithCreditProps = AreaImageProps & {
  isCreditShown: boolean,
};

const useStyles = makeStyles((theme) => ({
  image: {
    width: '100%',
  },
  imageContainer: {
    position: 'relative',
  },
  credit: {
    fontSize: 12,
    color: 'white',
    position: 'absolute',
    left: 6,
    bottom: 12,
  },
}));

const ImageWithCredit = ({
  src,
  title,
  isCreditShown = true,
}: ImageWithCreditProps) => {
  const classes = useStyles();
  return (
    <div className={classes.imageContainer}>
      <img src={src} alt={title} className={classes.image} />
      {isCreditShown && (
        <Typography className={classes.credit}>{CREDIT}</Typography>
      )}
    </div>
  );
};

export default ImageWithCredit;
